/* 劉備傳・第 4 章：白馬・封金辭曹（建安五年，200）
 * 史實：《三國志·關羽傳》「羽望見良麾蓋，策馬刺良於萬衆之中，斬其首還，紹諸將莫能當者，遂解白馬圍。」
 *       之後關羽「盡封其所賜，拜書告辭，而奔先主於袁軍。左右欲追之，曹公曰：『彼各爲其主，勿追也。』」
 *       （過五關斬六將是演義，放外傳。）
 * 流程：1. 白馬：操作關羽，望見顏良的麾蓋，殺穿萬眾直取顏良，斬其首帶回曹營。
 *       2. 封金：在曹營把曹操賞的東西一件件封好（站著讀條），寫書告辭；帶著劉備的家眷車駕往西北走。
 *          曹操下令不追，但關口的守將不知情：站在他旁邊就能說明情況放行；動手就少一顆星。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, TROOPS, PEOPLE, rout, vanish } from '../kit.ts';
import { YAN } from '../maps/baima.ts';

const LV = 12, CAMP = [1000, 2400], EXIT = [700, 700], POST = [1000, 1400];
const GIFTS = [[700, 2150], [1250, 2200], [650, 2650], [1300, 2650], [950, 2900]], DESK = [1000, 2450];
const YUAN = { spec: TROOPS.yuan, name: '袁軍', hp: 480, maxHp: 480, atk: 28 };

export default {
  id: 'liubei-4', map: 'baima', hero: 'guanyu',
  title: '第 4 章　白馬・封金辭曹', year: '建安五年（200）',
  brief: {
    quote: [{ text: '盡封其所賜，拜書告辭，而奔先主於袁軍。', src: '《三國志·蜀書·關羽傳》' }],
    text: '下邳一戰，劉備兵敗投奔袁紹，關羽被曹操所擒。曹操拜關羽為偏將軍，禮之甚厚；關羽說，受劉將軍厚恩，誓以共死，必立功報曹公而後去。',
    goals: ['白馬：殺穿萬眾，斬顏良，帶首級回營', '封金：封存曹操所賜，拜書告辭', '帶家眷出營，去找劉備'],
  },
  words: { ally: '曹軍', foe: '袁軍' },
  stars: [
    { text: '一分鐘內斬顏良', ok: (m) => m.vars.yanT != null && m.vars.yanT < 60 },
    { text: '五件賞賜全部封存', ok: (m) => m.vars.sealed === 5 },
    { text: '彼各為其主：出營時沒對曹軍動手', ok: (m) => !m.vars.foughtWei },
  ],
  steps: [
    { // 1. 白馬：刺良於萬眾之中
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = 1800; me.y = 2400;
        V.t0 = w.t;
        V.liao = ally(w, 'zhangliao', 1700, 2550, LV);
        V.yan = boss(w, PEOPLE.yanliang, YAN[0], YAN[1], { name: '顏良', hp: 3600, atk: 48, armor: 8 });
        V.wall = [];
        for (let r = 0; r < 3; r++) for (let i = 0; i < 5; i++) { const u = m.foe('huangjin', YAN[0] - 1300 + r * 380, YAN[1] - 320 + i * 160, YUAN); u.home = [u.x, u.y]; V.wall.push(u); }
        m.line('關羽', '那插著麾蓋的，就是顏良吧。');
        m.after(2.5, () => m.line('張遼', '雲長，要立功報曹公，就是今日！'));
        m.mark('yan', YAN[0], YAN[1], '顏良麾蓋', false, V.yan);
        m.obj('yan', '殺穿萬眾，斬顏良');
      },
      tick(m, w) { return !m.vars.yan.alive; },
    },
    { // 2. 斬其首還
      enter(m, w) {
        const V = m.vars;
        V.yanT = w.t - V.t0;
        m.done('yan'); m.unmark('yan');
        m.big('斬顏良！');
        m.card('羽望見良麾蓋，策馬刺良於萬衆之中，斬其首還，紹諸將莫能當者，遂解白馬圍。', '《關羽傳》');
        rout(m, w, V.wall, [8400, 2400]);
        m.mark('camp', CAMP[0], CAMP[1], '曹營');
        m.obj('back', '帶著首級回曹營');
      },
      tick(m, w) { return m.near(w.player, CAMP[0], CAMP[1], 400); },
    },
    { // 3. 封金
      enter(m, w) {
        const V = m.vars;
        m.done('back'); m.unmark('camp');
        vanish(w, V.liao);
        m.line('曹操', '雲長此功，可封漢壽亭侯！');
        m.after(3, () => m.line('關羽', '……曹公待我甚厚，然受劉將軍厚恩，誓以共死，不可背之。'));
        V.sealed = 0;
        V.gifts = GIFTS.map(([x, y], k) => { const p = SG.MAP.nearestFree(x, y); m.mark('gf' + k, p[0], p[1], '賞賜', true); return { x: p[0], y: p[1], done: false, f: m.folk(p[0], p[1], { name: '賞賜', still: true, near: 1, draw: chest }) }; });
        m.after(6, () => m.line('提示', '站在每件賞賜旁邊不動，把它封好；最後在帳中寫書告辭。'));
        m.obj('seal', '盡封其所賜', 5);
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        V.gifts.forEach((g, k) => { if (!g.done) m.chanAt(me, 'gf' + k, g.x, g.y, 120, 1.5, '封存', () => { g.done = true; g.f.sealed = true; V.sealed++; m.unmark('gf' + k); }); });
        m.prog('seal', V.sealed);
        if (V.sealed >= 3 && !V.deskOn) { V.deskOn = true; m.mark('desk', DESK[0], DESK[1], '拜書告辭'); }
        if (V.deskOn) m.chanAt(me, 'desk', DESK[0], DESK[1], 120, 2, '拜書告辭', () => { V.letter = true; });
        return !!V.letter;
      },
    },
    { // 4. 奔先主
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('seal'); m.unmark('desk');
        m.card('盡封其所賜，拜書告辭，而奔先主於袁軍。', '《關羽傳》');
        m.after(3, () => m.card('左右欲追之，曹公曰：「彼各爲其主，勿追也。」', '《關羽傳》'));
        V.carts = [0, 1].map((i) => { const u = m.recruit(me.x - 80 - i * 70, me.y + 60, '劉備家眷'); u.ms = 200; m.join(u, me); return u; });
        V.post = [-1, 1].map((s) => { const u = m.foe('huangjin', POST[0] + s * 110, POST[1], { spec: TROOPS.wei, name: '關口守將', hp: 900, maxHp: 900, atk: 34 }); u.asleep = true; u.home = [u.x, u.y]; return u; });
        m.mark('post', POST[0], POST[1], '關口');
        m.mark('exit', EXIT[0], EXIT[1], '往袁軍');
        m.obj('go', '帶家眷出營，去找劉備');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        // 關口：站在守將旁邊說明，就放行；對曹軍動手就記下
        if (V.post.some((u) => u.alive && u.hp < u.maxHp)) { V.foughtWei = true; for (const u of V.post) u.asleep = false; }
        if (!V.passed && !V.foughtWei) {
          for (const u of V.post) if (u.alive) { u.target = null; u.think = 0.5; }
          if (V.post.includes(me.input.target)) { me.input.target = null; me.input.engage = false; } // 還沒動手：關羽不會自己去打守將
          m.chanAt(me, 'post', POST[0], POST[1] + 120, 200, 2, '說明去意', () => { V.passed = true; m.line('關口守將', '丞相有令，不得阻攔。關將軍請。'); openPost(m); m.unmark('post'); });
        }
        if (!V.passed && !V.gated) { V.gated = true; for (const dx of [-900, -450, 0, 450, 900]) m.gate('post' + dx, POST[0] + dx, POST[1] - 60, 260, dx ? null : 'abatis'); } // 關口整排擋住
        if (V.foughtWei && m.alive(V.post).length === 0 && !V.passed) { openPost(m); V.passed = true; }
        if (!m.near(me, EXIT[0], EXIT[1], 300)) return false;
        m.done('go'); m.unmark('exit');
        m.line('關羽', '大哥，雲長來了。');
        m.after(3, () => m.win());
        return true;
      },
    },
    { tick() { return false; } },
  ],
  always(m, w) {
    if (!w.player.alive) { m.lose('關羽陣亡'); return; }
    if (m.vars.liao && m.vars.liao.alive) allyTick(w, m.vars.liao, w.player);
  },
};

function openPost(m) { for (const dx of [-900, -450, 0, 450, 900]) m.ungate('post' + dx); }

// 賞賜：漆箱；封好之後貼上封條
function chest(ctx, f, T) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 0, 3, 32, 9, 70, 0.3);
  poly(ctx, [[-28, 0], [28, 0], [28, -30], [-28, -30]], '#7a2a1c', 1.8);
  poly(ctx, [[-30, -30], [30, -30], [26, -40], [-26, -40]], '#9a3a28', 1.6);
  ctx.fillStyle = '#e0b04a'; ctx.fillRect(-4, -26, 8, 10);
  if (f.sealed) { ctx.fillStyle = '#e9dcb8'; ctx.save(); ctx.rotate(-0.4); ctx.fillRect(-34, -22, 68, 9); ctx.restore(); ctx.fillStyle = '#b0302a'; ctx.font = '900 10px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.fillText('封', 0, -16); }
  ctx.restore();
}
